import { gsap } from 'gsap'

import Page from './../../classes/Page'

export default class extends Page {
  constructor () {
    super({
      id: 'default',

      classes: {
        active: 'default--active'
      },

      element: '#main',
      elements: {
        // default: '.default'
      }
    })
  }

  create () {
    super.create()

    this.isError = document.querySelector('[data-template="error"]') ? true : false // errors/404 view
    
    if (this.isError) {
      console.log('create ERROR page');
    } else {
      console.log('create DEFAULT page');
    }

  }

  /**
   * Animations.
   */
  show () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.25
    }

    this.isPopState = false
    this.timelineIn = new gsap.timeline()

    // Reveal the page unconditionally: don't let it stay invisible if the
    // LoopingText.js chunk import is slow or fails (e.g. a ChunkLoadError).
    this.timelineIn.to(this.element, {
      duration: this.duration,
      autoAlpha: 1
    })

    if (this.isError) { // errors/404 view
      import(
        '../../components/LoopingText.js' /* webpackChunkName: "components/LoopingText" */
      ).then((LoopingText) => {
        this.loopingText = new LoopingText.default()
      }).catch((error) => {
        console.error('Failed to load LoopingText component', error)
      })
    }

    return super.show(this.timelineIn)
  }

  hide () {

    if (this.isPopState) {
      this.duration = 0
    } else {
      this.duration = 0.5
    }
    
    this.timelineOut = new gsap.timeline()

    this.timelineOut.to(this.element, {
      duration: this.duration,
      autoAlpha: 0
    })

    this.timelineOut.call(() => {
      this.destroy()
    })

    return super.hide(this.timelineOut)
  }

  /**
   * Events.
   */
  onTouchDown (event) {

  }

  onPopState () {
    this.isPopState = true
  }

  /**
   * Destroy.
   */
  destroy () {
    super.destroy()
  }
}
